// core/features/identity/hooks.ts
import {
    keepPreviousData,
    queryOptions,
    useQuery,
    useMutation,
    useQueryClient,
} from "@tanstack/react-query";
import {
    fetchIdentities,
    deleteIdentity,
    refreshIdentity,
    addIdentityForVerification,
} from "./api";
import type { IIdentityListResult } from "./types";

export const identityKeys = {
    root: ["identities"] as const,
    list: () => [...identityKeys.root, "list"] as const,
};

/** Query: all identities */
export const identitiesQuery = queryOptions<IIdentityListResult>({
    queryKey: identityKeys.list(),
    queryFn: fetchIdentities,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
});

export function useIdentities() {
    return useQuery(identitiesQuery);
}

/** Mutations */
export function useDeleteIdentity() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (email: string) => deleteIdentity(email),
        onSuccess: () => qc.invalidateQueries({ queryKey: identityKeys.root }),
    });
}

export function useRefreshIdentity() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (email: string) => refreshIdentity(email),
        onSuccess: () => qc.invalidateQueries({ queryKey: identityKeys.root }),
    });
}

// Todo: Adding the Resend Identity Functionality Back


export function useAddIdentity({ skipInvalidate = false } = {}) {
    const qc = useQueryClient();
  
    return useMutation({
      mutationFn: (body: { email: string; friendlyName: string }) =>
        addIdentityForVerification(body),
      onSuccess: (_data, _vars, _context) => {
        if (!skipInvalidate) qc.invalidateQueries({ queryKey: identityKeys.root });
      },
    });
  }